import Pill from '../Components/Pill'
import {useParams} from 'react-router-dom'
import AppearOnScroll from './AppearOnScroll';


function CenterTextImage(props) {
    let {projectName} = useParams();
    let project = require("../projects.json");
    let projectinfo = project.filter(project => project.project_name === projectName)[0];

    return (
        <div className=" flex flex-col w-full items-center gap-8 md:gap-12 ">
            <div className='flex flex-col items-start md:items-center md:w-60 gap-4'>
                <AppearOnScroll>
                {props.pill ? 
                <div className='flex flex-initial'>
                    <Pill>{props.pill}</Pill>
                </div> : <></>}
                </AppearOnScroll>
                <div className='flex flex-col text-left md:text-center gap-4 w-full text-wrap'>
                    <AppearOnScroll delay={0.2}>
                    <h1 className='text-2xl font-medium font-display'>{props.heading}</h1>
                    </AppearOnScroll>
                    <AppearOnScroll delay={0.1}>
                    <p className='text-lg font-normal font-body leading-relaxed'>{props.info}</p>
                    </AppearOnScroll>
                </div>
            </div>
            <div className="flex md:w-60 aspect-video border-1 border-lightgrey">
                <AppearOnScroll delay={0.1}>
                <img 
                    src={`/img/${projectinfo.folder}/${props.image}`}
                    alt={`Afbeelding voor ${projectinfo.project_name}`} 
                    className="rounded-image" 
                />
                </AppearOnScroll>
            </div>

        </div>
    );
  }
  
  export default CenterTextImage;